import {AppDataTable} from "@components"
import {Skeleton} from "@mui/material"
import {exportUrlColumn, officeDataColumn, reportNameColumn} from "Pages/Admin/GroupedExports/Modal/Table/@columns"
import React from "react"


export default function GroupedExportsModalTable({ data, isLoading }) {

	if (isLoading) return <Skeleton variant="rectangular" height={400}/>

	return <AppDataTable
		title="Export Information"
		data={data}
		columns={[ reportNameColumn(), ...officeDataColumn(), exportUrlColumn() ]}
	/>
}